<template>
  <div class="dashboard-page p-2 p-md-4">
    <!-- Header Page -->
    <div class="d-flex justify-content-between align-items-center mb-4">
      <div>
        <h3 class="fw-bold mb-1 text-dark">Dashboard Overview</h3>
        <p class="text-muted small mb-0">Ringkasan status dan data permohonan Anda</p>
      </div>
    </div>

    <div class="sidesWrapper">
      <div style="width:100%">

        <!-- STAT CARDS SECTION -->
        <b-row class="">
          <!-- Permohonan Card -->
          <b-col lg="4" md="6" xs="12">
            <Widget class="stat-card border-0 shadow-sm rounded-4" style="height: 70% !important;">
              <div class="d-flex align-items-start p-2">
                <div
                  class="icon-shape bg-primary-soft text-primary rounded-3 me-3 d-flex align-items-center justify-content-center">
                  <i class="fa fa-file-text fa-lg" />
                </div>
                <div>
                  <span class="text-uppercase text-muted fw-bold tracking-wider fs-7">PERMOHONAN</span>
                  <h2 class="fw-bold text-dark mb-1 mt-1">{{ dataDashboard.permohonan }}</h2>
                  <p class="text-muted small mb-0 stat-desc">
                    Total permohonan yang telah dibuat dan disubmit.
                  </p>
                </div>
              </div>
            </Widget>
          </b-col>

          <!-- Proses Card -->
          <b-col lg="4" md="6" xs="12">
            <Widget class="stat-card border-0 shadow-sm rounded-4" style="height: 70% !important;">
              <div class="d-flex align-items-start p-2">
                <div
                  class="icon-shape bg-warning-soft text-warning rounded-3 me-3 d-flex align-items-center justify-content-center">
                  <i class="fa fa-spinner fa-lg" />
                </div>
                <div>
                  <span class="text-uppercase text-muted fw-bold tracking-wider fs-7">PROSES</span>
                  <h2 class="fw-bold text-dark mb-1 mt-1">{{ dataDashboard.proses }}</h2>
                  <p class="text-muted small mb-0 stat-desc">
                    Total permohonan yang sedang diproses.
                  </p>
                </div>
              </div>
            </Widget>
          </b-col>

          <!-- Selesai Card -->
          <b-col lg="4" md="6" xs="12">
            <Widget class="stat-card border-0 shadow-sm rounded-4" style="height: 70% !important;">
              <div class="d-flex align-items-start p-2">
                <div
                  class="icon-shape bg-success-soft text-success rounded-3 me-3 d-flex align-items-center justify-content-center">
                  <i class="fa fa-check-circle fa-lg" />
                </div>
                <div>
                  <span class="text-uppercase text-muted fw-bold tracking-wider fs-7">SELESAI</span>
                  <h2 class="fw-bold text-dark mb-1 mt-1">{{ dataDashboard.selesai }}</h2>
                  <p class="text-muted small mb-0 stat-desc">
                    Total permohonan yang telah selesai diproses.
                  </p>
                </div>
              </div>
            </Widget>
          </b-col>
        </b-row>

        <!-- CARD 1: DATA PERMOHONAN BERUSAHA -->
        <b-row v-if="user.tipe_pemohon === 'swasta'" class="mb-4">
          <b-col xs="12">
            <Widget :title="`
        <div class='d-flex justify-content-between align-items-center w-100 p-2'>
          <div class='d-flex align-items-center'>
            <div class='header-icon-box me-3 text-primary bg-primary-soft rounded-circle d-flex align-items-center justify-content-center'>
              <i class='fa fa-briefcase'></i>
            </div>
            <div>
              <h5 class='fw-bold text-dark mb-0'>Data Permohonan Berusaha</h5>
              <p class='text-muted small mb-0'>Daftar seluruh pengajuan izin kategori berusaha</p>
            </div>
          </div>
          <div>
            <span class='badge bg-light text-dark border px-3 py-2 rounded-pill'>
              Total: ${rows || 0} Data
            </span>
          </div>
        </div>
      `" bodyClass="widget-table-overflow" customHeader class="border-0 shadow-sm rounded-4 overflow-hidden">

              <!-- Body Card & Table -->
              <template v-if="itemsWithNumber.length == 0">
                <div class="text-center py-5">
                  <img src="@/assets/empty.png" alt="Tidak ada data" class="img-fluid mb-3 opacity-75"
                    style="max-width: 140px;" />
                  <h6 class="fw-semibold text-dark">Belum ada data permohonan berusaha</h6>
                </div>
              </template>

              <template v-else>
                <div class="p-3">
                  <div class="table-responsive mb-3 datatables">
                    <b-table hover borderless align="middle" class="custom-table" :items="itemsWithNumber"
                      :fields="fieldsBerusaha" responsive="sm" :per-page="perPage" :current-page="currentPage"
                      :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :filter="filter"
                      :filter-included-fields="filterOn" @filtered="onFiltered">
                      <template #cell(tanggal_permohonan)="data">
                        {{ format_date(data.item.tanggal_pada_permohonan) }}
                      </template>
                      <template #cell(status_permohonan)="data">
                        <b-badge pill :variant="getStatusBadge(data.item.status_permohonan).variant"
                          class="px-3 py-2 fw-semibold custom-badge">
                          <i :class="getStatusBadge(data.item.status_permohonan).icon" class="me-1"></i>
                          {{ data.item.status_permohonan }}
                        </b-badge>
                      </template>
                    </b-table>
                  </div>

                  <!-- Control Footer -->
                  <div class="d-flex justify-content-between align-items-center pt-3 border-top">
                    <div class="d-flex align-items-center">
                      <b-form-select class="form-select form-select-sm" style="width: 80px;" v-model="perPage" size="sm"
                        :options="pageOptions"></b-form-select>
                    </div>
                    <div>
                      <b-pagination pills size="sm" v-model="currentPage" :total-rows="rows"
                        :per-page="perPage"></b-pagination>
                    </div>
                  </div>
                </div>
              </template>
            </Widget>
          </b-col>
        </b-row>

        <!-- CARD 2: DATA PERMOHONAN NON BERUSAHA -->
        <b-row class="mb-4">
          <b-col xs="12">
            <Widget :title="`
        <div class='d-flex justify-content-between align-items-center w-100 p-2'>
          <div class='d-flex align-items-center'>
            <div class='header-icon-box me-3 text-info bg-info-soft rounded-circle d-flex align-items-center justify-content-center'>
              <i class='fa fa-folder-open'></i>
            </div>
            <div>
              <h5 class='fw-bold text-dark mb-0'>Data Permohonan Non Berusaha</h5>
              <p class='text-muted small mb-0'>Daftar seluruh pengajuan izin kategori non-berusaha</p>
            </div>
          </div>
          <div>
            <span class='badge bg-light text-dark border px-3 py-2 rounded-pill'>
              Total: ${rowsNonber || 0} Data
            </span>
          </div>
        </div>
      `" bodyClass="widget-table-overflow" customHeader class="border-0 shadow-sm rounded-4 overflow-hidden">

              <!-- Body Card & Table -->
              <template v-if="itemsWithNumberNonber.length == 0">
                <div class="text-center py-5">
                  <img src="@/assets/empty.png" alt="Tidak ada data" class="img-fluid mb-3 opacity-75"
                    style="max-width: 140px;" />
                  <h6 class="fw-semibold text-dark">Belum ada data permohonan non-berusaha</h6>
                </div>
              </template>

              <template v-else>
                <div class="p-3">
                  <div class="table-responsive mb-3 datatables">
                    <b-table hover borderless align="middle" class="custom-table" :items="itemsWithNumberNonber"
                      :fields="fields" responsive="sm" :per-page="perPageNonber" :current-page="currentPageNonber"
                      :sort-by.sync="sortByNonber" :sort-desc.sync="sortDescNonber" :filter="filterNonber"
                      :filter-included-fields="filterOnNonber" @filtered="onFilteredNonber">
                      <template #cell(tanggal_permohonan)="data">
                        {{ format_date(data.item.tanggal_permohonan) }}
                      </template>
                      <template #cell(status_permohonan)="data">
                        <b-badge pill :variant="getStatusBadge(data.item.status_permohonan).variant"
                          class="px-3 py-2 fw-semibold custom-badge">
                          <i :class="getStatusBadge(data.item.status_permohonan).icon" class="me-1"></i>
                          {{ data.item.status_permohonan }}
                        </b-badge>
                      </template>
                    </b-table>
                  </div>

                  <!-- Control Footer -->
                  <div class="d-flex justify-content-between align-items-center pt-3 border-top">
                    <div class="d-flex align-items-center">
                      <b-form-select class="form-select form-select-sm" style="width: 80px;" v-model="perPageNonber"
                        size="sm" :options="pageOptionsNonber"></b-form-select>
                    </div>
                    <div>
                      <b-pagination pills size="sm" v-model="currentPageNonber" :total-rows="rowsNonber"
                        :per-page="perPageNonber"></b-pagination>
                    </div>
                  </div>
                </div>
              </template>
            </Widget>
          </b-col>
        </b-row>

      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import Widget from '@/components/Widget/Widget';
import MainChart from './components/MainChart/MainChart';
import BigStat from './components/BigStat/BigStat';
import Calendar from '../Visits/components/Calendar/Calendar';
import TaskContainer from './components/TaskContainer/TaskContainer';
import mock from './mock';
import axios from 'axios';
import moment from 'moment'

import { Chart } from 'highcharts-vue';
import IzinProvChart from './components/MainChart/IzinProvChart.vue';
import IzinPNBPChart from './components/MainChart/IzinPNBPChart.vue';
import IzinYearChart from './components/MainChart/IzinYearChart.vue';


export default {
  name: 'Dashboard',
  components: {
    Widget,
    MainChart,
    BigStat,
    Calendar,
    TaskContainer,
    highcharts: Chart,
    IzinProvChart,
    IzinYearChart,
    IzinPNBPChart
  },
  data() {
    return {
      mock,
      baseapi: localStorage.getItem("baseapi"),
      user: JSON.parse(localStorage.getItem('user')),
      dataPermohonan: [],
      dataPermohonanNonber: [],
      dataDashboard: [],
      fields: [
        'no',
        { key: "nama_pemohon", sortable: true },
        { key: "instansi_pemohon", sortable: true },
        { key: "nomor_permohonan", sortable: true },
        { key: "jenis_kegiatan", sortable: true },
        { key: "status_permohonan", label: "Status", sortable: true },
        { key: "tanggal_permohonan", label: "Tanggal Permohonan" },
      ],
      fieldsBerusaha: [
        'no',
        { key: "nama_pemohon", sortable: true },
        { key: "nomor_permohonan", sortable: true },
        { key: "jenis_kegiatan", sortable: true },
        { key: "status_permohonan", label: "Status", sortable: true },
        { key: "tanggal_permohonan", label: "Tanggal Permohonan" },
      ],
      optionsDatatable: {
        perPage: 10,
        pagination: { chunk: 10, dropdown: false },
        texts: { filter: '', count: '', limit: '' },
        columnsClasses: { id: 'width-100' },
        skin: 'table table-striped',
        sortIcon: {
          base: 'fa text-muted', up: 'fa-chevron-up', down: 'fa-chevron-down', is: 'fa-sort',
        },
      },
      items: [],
      itemsNonber: [],
      currentPage: 1,
      currentPageNonber: 1,
      perPage: 10,
      perPageNonber: 10,
      pageOptions: [10, 25, 50, 100],
      pageOptionsNonber: [10, 25, 50, 100],
      filter: null,
      filterNonber: null,
      filterOn: [],
      filterOnNonber: [],
      sortBy: "name",
      sortByNonber: "name",
      sortDesc: false,
      sortDescNonber: false,
      totalRows: 1,
      totalRowsNonber: 1,
    };
  },
  methods: {
    ...mapActions('dashboard', ['receiveDataRequest']),
    getRandomData() {
      const arr = [];

      for (let i = 0; i < 25; i += 1) {
        arr.push(Math.random().toFixed(1) * 10);
      }

      return arr;
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    onFilteredNonber(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRowsNonber = filteredItems.length;
      this.currentPageNonber = 1;
    },

    loaddata() {
      axios.get(this.baseapi + 'api/permohonan?filter=npwp_pemohon,=,' + this.user.npwp, {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken
        }
      }).then(response => {
        this.dataPermohonan = response.data.data;
      }).catch(error => {
        console.log(error)
        return error
      });
    },

    loaddatanonber() {
      axios.get(this.baseapi + 'api/permohonan_nonberusaha?filter=id_pembuat,=,' + this.user.id, {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken
        }
      }).then(response => {
        this.dataPermohonanNonber = response.data.data;
      }).catch(error => {
        console.log(error)
        return error
      });
    },

    loadDataDashboard() {
      axios.get(this.baseapi + 'api/dashboard/web', {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken
        }
      }).then(response => {
        this.dataDashboard = response.data.data;
      }).catch(error => {
        console.log(error)
        return error
      });
    },
    format_date(value) {
      if (value) {
        return moment(String(value)).format('DD MMMM YYYY')
      }
    },
    getStatusBadge(status) {
      switch (status) {
        case 'Selesai':
          return { variant: 'success', icon: 'fa fa-check' };
        case 'Perbaikan Persyaratan':
        case 'Penolakan':
          return { variant: 'danger', icon: 'fa fa-times' };
        case 'Permohonan telah dibuat oleh pemohon':
          return { variant: 'warning', icon: 'fa fa-clock-o' };
        default:
          return { variant: 'info', icon: 'fa fa-info-circle' };
      }
    }
  },
  computed: {
    ...mapState('dashboard', [
      'visits',
      'performance',
      'server',
      'revenue',
      'mainChart',
      'isReceiving',
    ]),
    itemsWithNumber() {
      return this.dataPermohonan.map((d, index) => ({ ...d, no: index + 1 }))
    },
    rows() {
      return this.dataPermohonan.length;
    },
    itemsWithNumberNonber() {
      return this.dataPermohonanNonber.map((d, index) => ({ ...d, no: index + 1 }))
    },
    rowsNonber() {
      return this.dataPermohonanNonber.length;
    },
    donut() {
      let { danger, warning, primary } = this.appConfig.colors;
      let series = [
        {
          name: 'Revenue',
          data: this.revenue.map(s => {
            return {
              name: s.label,
              y: s.data
            }
          })
        }
      ];
      return {
        chart: {
          type: 'pie',
          height: 120
        },
        credits: {
          enabled: false
        },
        title: false,
        plotOptions: {
          pie: {
            dataLabels: {
              enabled: false
            },
            borderColor: null,
            showInLegend: true,
            innerSize: 60,
            size: 100,
            states: {
              hover: {
                halo: {
                  size: 1
                }
              }
            }
          }
        },
        colors: [danger, warning, primary],
        legend: {
          align: 'right',
          verticalAlign: 'middle',
          layout: 'vertical',
          itemStyle: {
            color: '#495057',
            fontWeight: 100,
            fontFamily: 'Montserrat'
          },
          itemMarginBottom: 5,
          symbolRadius: 0
        },
        exporting: {
          enabled: false
        },
        series
      };
    }
  },
  mounted() {
    this.receiveDataRequest();
    this.loaddata()
    this.loaddatanonber()
    this.loadDataDashboard()
    this.totalRows = this.items.length;
    this.totalRowsNonber = this.itemsNonber.length;
  },
};
</script>

<style src="./Dashboard.scss" lang="scss" />

<style scoped>
/* ==========================================================================
   1. UTILITY & GENERAL STYLES
   ========================================================================== */
.fs-7 {
  font-size: 0.75rem;
}

.tracking-wider {
  letter-spacing: 0.05em;
}

/* ==========================================================================
   2. TOP STAT CARDS STYLING
   ========================================================================== */
.stat-card {
  background-color: #ffffff;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.stat-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 0.5rem 1.25rem rgba(0, 0, 0, 0.08) !important;
}

.icon-shape {
  width: 52px;
  height: 52px;
  flex-shrink: 0;
}

/* Soft Color Variants for Icons & Backgrounds */
.bg-primary-soft {
  background-color: rgba(13, 110, 253, 0.12) !important;
}

.bg-warning-soft {
  background-color: rgba(255, 193, 7, 0.15) !important;
}

.bg-success-soft {
  background-color: rgba(25, 135, 84, 0.12) !important;
}

.bg-info-soft {
  background-color: rgba(13, 202, 240, 0.12) !important;
}

/* ==========================================================================
   3. WIDGET / CARD HEADER STYLING
   ========================================================================== */
.card-header-modern {
  background-color: #ffffff;
  border-bottom: 1px solid #f1f3f5;
}

.header-icon-box {
  width: 42px;
  height: 42px;
  font-size: 1.1rem;
  flex-shrink: 0;
}

/* ==========================================================================
   4. TABLE STYLING
   ========================================================================== */
.custom-table {
  width: 100%;
  margin-bottom: 0;
}

.custom-table th {
  font-weight: 600;
  text-transform: uppercase;
  font-size: 0.75rem;
  letter-spacing: 0.5px;
  color: #6c757d;
  background-color: #f8f9fa;
  border-bottom: 1px solid #e9ecef !important;
  padding: 12px 16px;
  white-space: nowrap;
}

.custom-table td {
  padding: 14px 16px;
  border-bottom: 1px solid #f1f3f5;
  font-size: 0.875rem;
  vertical-align: middle;
}

.custom-table tbody tr {
  transition: background-color 0.15s ease;
}

.custom-table tbody tr:hover {
  background-color: #f8f9fa;
}

/* Avatar User di Kolom Tabel (jika digunakan) */
.avatar-sm {
  width: 32px;
  height: 32px;
  font-size: 0.85rem;
  flex-shrink: 0;
}

/* ==========================================================================
   5. BADGES & STATUS STYLING
   ========================================================================== */
.custom-badge {
  font-size: 0.75rem !important;
  letter-spacing: 0.2px;
  font-weight: 600;
}

/* ==========================================================================
   6. PAGINATION & CONTROLS STYLING
   ========================================================================== */
.custom-pagination .page-link {
  border: none;
  color: #6c757d;
  font-weight: 500;
  margin: 0 2px;
  border-radius: 50% !important;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.custom-pagination .page-item.active .page-link {
  background-color: #0d6efd;
  color: #ffffff;
  box-shadow: 0 2px 6px rgba(13, 110, 253, 0.3);
}

.custom-pagination .page-item.disabled .page-link {
  background-color: transparent;
  color: #ced4da;
}

.align-items-start {
  align-items: flex-start !important;
}

.stat-desc {
  font-size: 0.8rem;
  line-height: 1.3;
  color: #6c757d;
}
</style>